import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  Alert,
  FormFeedback,
} from "reactstrap";
import {
  validationHelper,
  formatHelper,
  normalizeHelper,
} from "../../../../common/helpers";
import { messages } from "../../../../common/constants";
import { toast } from "react-toastify";
import {
  createProduct,
  resetCreateProduct,
} from "../../../../store/product/actions";
import { getIGV } from "../../../../store/sell/actions";
import { getCategories } from "../../../../store/category/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { roles } from "../../../../common/constants";
import { getProviders } from "../../../../store/provider/actions";
import { MainLoader } from "../../../../components";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

class ProductAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgV: null,
      imgH: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.renderCategoriesField = this.renderCategoriesField.bind(this);
    this.renderProvidersField = this.renderProvidersField.bind(this);
    this.renderImgField = this.renderImgField.bind(this);
  }

  componentDidMount() {
    this.props.getCategories({ reset: true });
    this.props.getProviders({ reset: true });
    this.props.getIGV();
  }

  componentDidUpdate(prevProps) {
    this.checkDiscountChange(prevProps);
    this.checkProductCreationSuccess(prevProps);
  }

  componentWillUnmount() {
    this.props.resetCreateProduct();
  }

  checkProductCreationSuccess(prevProps) {
    if (prevProps.product == null && this.props.product != null) {
      toast.success("Producto creado satisfactoriamente");
      this.props.history.push("/administration/products");
    }
  }

  onSubmit(values) {
    if (values.category_id == "0") delete values.category_id;
    if (values.discount) values.discount = values.discount / 100;
    if (
      values.discount_corporative &&
      !isNaN(Number(values.discount_corporative))
    )
      values.discount_corporative = values.discount_corporative / 100;
    else {
      delete values.discount_corporative;
      delete values.price_discount_corporative;
    }

    this.props.createProduct(values, this.state.imgV, this.state.imgH);
  }

  renderInputField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderStaticField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col xs="12" md="5">
          <Input
            {...field.input}
            invalid={hasError}
            type={field.type}
            readOnly
          />
        </Col>
      </FormGroup>
    );
  }

  checkDiscountChange(prevProps) {
    if (
      (prevProps.discountValue != this.props.discountValue &&
        this.props.discountValue != null) ||
      (prevProps.priceValue != this.props.priceValue &&
        this.props.priceValue != null)
    ) {
      const { discountValue, priceValue } = this.props;
      if (!discountValue || !priceValue) return;
      let priceDiscount = formatHelper.toTwoDecimal(
        (priceValue * (100 - discountValue)) / 100
      );

      this.props.changeValueForm(
        "ProductAddForm",
        "price_discount",
        priceDiscount
      );
    }
    if (
      (prevProps.priceDiscountCorporativeValue !=
        this.props.priceDiscountCorporativeValue &&
        this.props.priceDiscountCorporativeValue != null) ||
      (prevProps.priceValue != this.props.priceValue &&
        this.props.priceValue != null)
    ) {
      const { priceDiscountCorporativeValue, priceValue } = this.props;
      if (!priceDiscountCorporativeValue || !priceValue) return;
      let discountCorporative = formatHelper.toTwoDecimal(
        ((priceValue - priceDiscountCorporativeValue) / priceValue) * 100
      );

      this.props.changeValueForm(
        "ProductAddForm",
        "discount_corporative",
        discountCorporative
      );
    }
  }

  renderPriceWithoutTax() {
    const { priceValue, igv } = this.props;
    let value = "";
    if (igv)
      value =
        priceValue != null
          ? formatHelper.toTwoDecimal(priceValue / (1 + 0.18))
          : "";

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label>Precio sin IGV (S/):</Label>
        </Col>
        <Col xs="12" md="5">
          <Label>{value}</Label>
        </Col>
      </FormGroup>
    );
  }

  renderCategoryItems() {
    return this.props.categories.map((category) => {
      return (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      );
    });
  }

  renderCategoriesField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label htmlFor="select">Categoría *:</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {this.renderCategoryItems()}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderProviderItems() {
    return this.props.providers.map((provider) => {
      return (
        <option key={provider.id} value={provider.id}>
          {provider.name}
        </option>
      );
    });
  }

  renderProvidersField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;

    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label htmlFor="select">Proveedor *:</Label>
        </Col>
        <Col xs="12" md="5">
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {this.renderProviderItems()}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderImgField(label, img) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label>{label}</Label>
        </Col>
        <Col xs="12" md="5">
          <FilePond
            labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
            acceptedFileTypes="image/jpeg, image/png"
            labelFileTypeNotAllowed="Archivo no válido"
            onupdatefiles={(fileItems) => {
              if (fileItems.length == 0) return;
              if (img === "vertical")
                this.setState({ imgV: fileItems[0].file });
              else this.setState({ imgH: fileItems[0].file });
            }}
            onremovefile={(file) => {
              if (img === "vertical") this.setState({ imgV: null });
              else this.setState({ imgH: null });
            }}
          />
        </Col>
      </FormGroup>
    );
  }

  render() {
    const {
      handleSubmit,
      loading,
      error,
      categoriesLoading,
      providersLoading,
      igvLoading,
      role,
    } = this.props;

    if (categoriesLoading || providersLoading || igvLoading) {
      return <MainLoader />;
    }

    return (
      <div className="animated">
        <Card>
          <CardHeader>Nuevo Producto</CardHeader>
          <CardBody>
            {error && <Alert color="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))}>
              <Field
                name="name"
                label="Nombre *:"
                type="text"
                component={this.renderInputField}
              />
              <Field
                name="code"
                label="Código:"
                type="text"
                component={this.renderInputField}
              />
              <Field
                name="price"
                label="Precio (S/) *:"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField()}
              />
              {this.renderPriceWithoutTax()}
              <Field
                name="cost"
                label="Costo (S/):"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField()}
              />
              <Field
                name="discount"
                label="Descuento (%):"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField(0, 100)}
              />
              <Field
                name="price_discount"
                label="Precio con Descuento (S/):"
                type="text"
                component={this.renderStaticField}
              />
              <Field
                name="discount_corporative"
                label="Descuento Corporativo (%):"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.decimalOnlyField(0, 100)}
              />
              <Field
                name="price_discount_corporative"
                label="Precio Con Descuento Corporativo (S/):"
                type="text"
                component={this.renderStaticField}
              />
              {role == roles.SUPER_ADMIN && (
                <React.Fragment>
                  <Field
                    name="app_name"
                    label="Nombre en aplicación móvil:"
                    type="text"
                    component={this.renderInputField}
                  />
                  <Field
                    name="app_points"
                    label="Puntos en aplicación móvil:"
                    type="text"
                    component={this.renderInputField}
                    normalize={normalizeHelper.numberOnlyField()}
                  />
                </React.Fragment>
              )}
              {this.renderImgField("Imagen Vertical (900x1280):", "vertical")}
              {this.renderImgField(
                "Imagen Horizontal (1200x700):",
                "horizontal"
              )}
              <Field
                name="category_id"
                component={this.renderCategoriesField}
              />
              <Field name="provider_id" component={this.renderProvidersField} />
              <Row>
                <Col className="mt-3">
                  <Button
                    type="submit"
                    disabled={loading}
                    color="primary"
                    className="mr-2"
                  >
                    <i className="fa fa-save mr-1" /> Guardar
                  </Button>
                  <Button
                    color="secondary"
                    onClick={() =>
                      this.props.history.push("/administration/products")
                    }
                  >
                    <i className="fa fa-chevron-left mr-1" /> Cancelar
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (validationHelper.stringIsNullOrEmpty(values.name)) {
    errors.name = messages.MANDATORY_FIELD;
  }

  if (validationHelper.stringIsNullOrEmpty(values.price)) {
    errors.price = messages.MANDATORY_FIELD;
  } else if (!validationHelper.isMoney(values.price)) {
    errors.price = messages.DECIMAL_FORMAT_FIELD;
  }

  if (
    !validationHelper.isMoney(values.cost) &&
    !validationHelper.stringIsNullOrEmpty(values.cost)
  ) {
    errors.cost = messages.DECIMAL_FORMAT_FIELD;
  }

  if (
    validationHelper.stringIsNullOrEmpty(values.category_id) ||
    values.category_id == "0"
  ) {
    errors.category_id = messages.MANDATORY_FIELD;
  }

  if (
    validationHelper.stringIsNullOrEmpty(values.provider_id) ||
    values.provider_id == "0"
  ) {
    errors.provider_id = messages.MANDATORY_FIELD;
  }

  return errors;
}

const formSelector = formValueSelector("ProductAddForm");

function mapStateToProps(state) {
  const { product, loading, error } = state.product.newProduct;
  const { activeIGV } = state.sell;
  const { providerList } = state.provider;
  const { categoryList } = state.category;

  return {
    product,
    loading,
    error,
    categories: categoryList.categories,
    categoriesLoading: categoryList.loading,
    providers: providerList.providers,
    providersLoading: providerList.loading,
    priceValue: formSelector(state, "price"),
    discountValue: formSelector(state, "discount"),
    discountCorporativeValue: formSelector(state, "discount_corporative"),
    priceDiscountCorporativeValue: formSelector(
      state,
      "price_discount_corporative"
    ),
    igv: activeIGV.igv,
    igvLoading: activeIGV.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createProduct,
      getCategories,
      getProviders,
      resetCreateProduct,
      getIGV,
      changeValueForm: change,
    },
    dispatch
  );
}

export default reduxForm({
  form: "ProductAddForm",
  touchOnBlur: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ProductAdd));



// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductAdd/ProductAdd.js